<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » エントリー情報検索条件の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>エントリー情報検索条件の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/select-entrance-exit-entry-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png">閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png">検索条件
        </div>
        <div class="manual-explain">
          イベント：<br>
          イベントを選択します。イベントを選択した場合はエントリー番号は未設定となります。<br>
          エントリー番号：<br>
          エントリー番号を設定します。エントリー番号を設定した場合はイベントは未設定となります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png">検索ボタン
        </div>
        <div class="manual-explain">
          検索条件に設定された内容でエントリー情報を検索します。<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Entry Information Search Conditions
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Entry Information Search Conditions</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_select-entrance-exit-entry-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Search Conditions
        </div>
        <div class="manual-explain">
          Event:<br>
          Select an event. When an event is selected, the entry number will be unset.<br>
          Entry Number:<br>
          Set the entry number. When an entry number is set, the event will be unset.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Search Button
        </div>
        <div class="manual-explain">
          Search for entry information with the content set in the search conditions.<br>
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
